import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';
import CustomerConfig from "../azure/CustomerConfig";
const browserHistory = createBrowserHistory({ basename: '' });
const reactPlugin = new ReactPlugin();
require('dotenv').config()

let REACT_APP_APPINSIGHTS_KEY = new CustomerConfig().getAppInsightKey();
console.log("AppInsightsKey: " + REACT_APP_APPINSIGHTS_KEY);
const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: REACT_APP_APPINSIGHTS_KEY,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
  },
});
if(REACT_APP_APPINSIGHTS_KEY !== null)
{
  appInsights.loadAppInsights();
}
export { reactPlugin, appInsights };